// Shared application chat room naming (must match backend buildApplicationRoomName)

export const formatApplicationChatRoomName = (sentDate, handle) => {
  if (!sentDate || !handle) return "";
  const formattedDate = new Date(sentDate).toLocaleString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });
  return `${formattedDate}: ${handle}`;
};

export const isApplicationChatRoomName = (roomName) => {
  if (!roomName || typeof roomName !== "string") return false;
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/i.test(roomName)) return false;
  return /^.+: .+$/.test(roomName);
};

export const hasUnreadApplicationChats = (unreadMap) =>
  Object.entries(unreadMap || {}).some(
    ([roomName, hasUnread]) =>
      hasUnread === true && isApplicationChatRoomName(roomName)
  );
